module.exports = __webpack_public_path__ + "img/color_block_3.eaec4a86.svg";